import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import NavSection from './NavSection.component';
import { Section } from '../../../types/server-data/ClientConfig';
import { clientSectionsSelector } from '../../../redux/pages/selectors';
import makeStyles from '@mui/styles/makeStyles';
import { useHorizontalScrollIndicators } from '../../../hooks/useHorizontalScrollIndicators';
import { ScrollArrowButton } from './ScrollArrowButton';

const useIndicatiorStyles = makeStyles({
  fadeIndicator: {
    position: 'absolute',
    top: 0,
    height: '100%',
    width: '20px',
    pointerEvents: 'none',
    zIndex: 1,
  },
  leftFade: {
    left: 0,
    background:
      'linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)',
  },
  rightFade: {
    right: 0,
    background:
      'linear-gradient(to left, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)',
  },
});

type FadeIndicatorProps = {
  direction: 'left' | 'right';
};

export const FadeIndicator: React.FC<FadeIndicatorProps> = ({ direction }) => {
  const classes = useIndicatiorStyles();
  return (
    <div
      className={`${classes.fadeIndicator} ${
        direction === 'left' ? classes.leftFade : classes.rightFade
      }`}
    />
  );
};

const NavContainer: React.FC = (): ReactElement => {
  const {
    containerRef,
    showLeftIndicator,
    showRightIndicator,
    handleScrollLeft,
    handleScrollRight,
  } = useHorizontalScrollIndicators<HTMLDivElement>();

  const clientSections = useSelector(clientSectionsSelector) || [];

  return (
    <div className="relative flex h-full w-full items-center overflow-hidden">
      <div
        className="transition-opacity duration-200"
        style={{
          opacity: showLeftIndicator ? 1 : 0,
          pointerEvents: showLeftIndicator ? 'auto' : 'none',
        }}
      >
        <ScrollArrowButton direction="left" onClick={handleScrollLeft} />
      </div>

      <div className="relative w-full overflow-hidden">
        <div
          ref={containerRef}
          className="noscrollbar flex items-center gap-3 overflow-x-auto"
        >
          {showLeftIndicator && <FadeIndicator direction="left" />}

          {clientSections.map((section: Section) => (
            <NavSection key={section.sectionId} section={section} />
          ))}
          {showRightIndicator && <FadeIndicator direction="right" />}
        </div>
      </div>

      <div
        className="transition-opacity duration-200"
        style={{
          opacity: showRightIndicator ? 1 : 0,
          pointerEvents: showRightIndicator ? 'auto' : 'none',
        }}
      >
        <ScrollArrowButton direction="right" onClick={handleScrollRight} />
      </div>
    </div>
  );
};

export default NavContainer;
